module.exports = __webpack_public_path__ + "img/art.59cda537.svg";